import 'styles/App.css';
import 'styles/colors.css';
import 'styles/darwin-styles/darwin-sizes.css';
import 'styles/darwin-styles/darwin-bottom.css';
import 'styles/darwin-styles/darwin-color.css';
import 'styles/darwin-styles/darwin-text.css';
import 'styles/darwin-styles/darwin-component.css';
import 'styles/darwin-styles/darwin-spacing.css';
import 'styles/darwin-styles/darwin-input.css';
// import 'rsuite/dist/rsuite-no-reset.min.css';
import AppLayout from 'components/ui/layout/Layout';
import { NotificationContext } from 'contexts/FloatNotificationContext';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from 'contexts/AuthContext';
import { Web3AuthProvider } from '@web3auth/no-modal-react-hooks';
import { web3AuthContextConfig } from 'contexts/Web3AuthContext';
import { Web3Context } from 'contexts/Web3Context';
import { UIProvider } from 'contexts/UiContext';
import { CreateOrganizationFormContextProvider } from 'contexts/CreateOrganizationFormContext';
import { Outlet } from 'react-router-dom';
import { ReactFlowProvider } from '@xyflow/react';
import { ReportsFiltersProvider } from 'contexts/ReportsFiltersContext';

const queryClient = new QueryClient();

export default function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#EE6002',
          colorInfo: '#A4ABBE',
          fontFamily: 'Roboto',
          fontSizeLG: 14,
          fontSizeHeading3: 22,
          fontSizeHeading5: 14,
          colorText: '#565656',
        },
        components: {
          Button: {
            colorPrimaryHover: '#CCC',
          },
          Table: {
            headerSplitColor: 'transparent',
            headerColor: 'var(--gray-3-color)',
            rowHoverBg: 'var(--gray-8-color)',
          },
          Typography: {
            titleMarginTop: 0,
            titleMarginBottom: 0,
          },
          Select: {
            optionFontSize: 14,
          },
          Dropdown: {
            paddingBlock: 10,
          },
          Form: {
            labelHeight: 80,
          },
        },
      }}
    >
      <NotificationContext>
        <Web3AuthProvider config={web3AuthContextConfig}>
          <Web3Context>
            <ReactFlowProvider>
              <UIProvider>
                <CreateOrganizationFormContextProvider>
                  <ReportsFiltersProvider>
                    <QueryClientProvider client={queryClient}>
                      <div
                        style={{
                          position: 'fixed',
                          top: 0,
                          bottom: 0,
                          left: 0,
                          right: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontFamily: 'sans-serif',
                        }}
                      >
                        <AuthProvider>
                          <AppLayout>
                            <Outlet />
                          </AppLayout>
                        </AuthProvider>
                      </div>
                    </QueryClientProvider>
                  </ReportsFiltersProvider>
                </CreateOrganizationFormContextProvider>
              </UIProvider>
            </ReactFlowProvider>
          </Web3Context>
        </Web3AuthProvider>
      </NotificationContext>
    </ConfigProvider>
  );
}
